import { Form, Input, Alert } from "antd";
import { requiredPromptRule } from "./aiConfigPayloads";

const { TextArea } = Input;

const PROMPT_NOTE = (
  <>
    <strong>Note:</strong> Must wrap the prompt with <code>"""</code> (three double quotes) at the
    start and end. Must maintain the example structure of the prompt. One prompt serves both English
    and Arabic: the backend adds a <code>LANGUAGE: en|ar</code> line at the top of the user message.
  </>
);

const PromptFields = ({ showNoStoredPrompt = false }) => (
  <>
    {showNoStoredPrompt && (
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="No stored prompt: the code default is used until you save one"
      />
    )}
    <Form.Item
      label="System Prompt"
      name="system_prompt"
      rules={[requiredPromptRule("System prompt")]}
      extra={PROMPT_NOTE}
    >
      <TextArea rows={4} placeholder="Enter system prompt..." dir="auto" />
    </Form.Item>

    <Form.Item
      label="User Prompt"
      name="user_prompt"
      rules={[requiredPromptRule("User prompt")]}
      extra={PROMPT_NOTE}
    >
      <TextArea rows={4} placeholder="Enter user prompt..." dir="auto" />
    </Form.Item>
  </>
);

export default PromptFields;
